import React from 'react';
import { Link } from 'react-router-dom';
import usePointerVars from '../hooks/usePointerVars';
import useMotionPrefs from '../hooks/useMotionPrefs';
import { ArrowRight } from './icons';

/* ==================================================================
   MagneticButton
   ------------------------------------------------------------------
   A CTA that leans a few pixels toward the cursor and carries a soft
   light that tracks it. The pull is pure CSS off --hs-mx / --hs-my,
   so the "magnet" costs one rAF-throttled style write per frame and
   nothing at all on touch devices or under reduced motion.

   Renders a router <Link> for `to`, an <a> for `href`, else a <button>.
   ================================================================== */

export default function MagneticButton({
  to,
  href,
  variant = 'primary',
  size = 'md',
  strength = 7,
  arrow = false,
  className = '',
  children,
  ...rest
}) {
  const { reduced, pointer } = useMotionPrefs();
  const ref = usePointerVars({ disabled: reduced || !pointer });

  const Tag = to ? Link : href ? 'a' : 'button';
  const tagProps = to ? { to } : href ? { href } : { type: 'button' };

  return (
    <Tag
      ref={ref}
      className={`hs-btn hs-btn--${variant} hs-btn--${size} ${className}`.trim()}
      style={{ '--hs-mag': `${strength}px` }}
      {...tagProps}
      {...rest}
    >
      <span className="hs-btn__glow" aria-hidden="true" />
      <span className="hs-btn__label">
        {children}
        {arrow && (
          <span className="hs-btn__arrow">
            <ArrowRight size={17} />
          </span>
        )}
      </span>
    </Tag>
  );
}
